export const isObject = (value: unknown): value is object =>
    Boolean(value && typeof value === 'object' && value.constructor === Object);

export const isFilledObject = (value: unknown): value is object =>
    isObject(value) && Object.keys(value).length > 0;
